
<template>
  <div class="mt-2 flex  overflow-hidden flex-grow ">
    <div class="overflow-hidden  flex flex-col pb-4 flex-grow bg-trader-gray mr-2 ">

      <!--go back  -->
      <div class="w-full  h-10 ">
        <CGoBack/>
      </div>

      <!--Bearbeitung Weißer hintergrund  -->
      <div class=" flex-grow overflow-hidden px-10 h-full  flex  text-center justify-center">

        <div class=" overflow-auto bg-white rounded p-10  max-w-[1000px] flex-grow">

          <div class="flex items-center justify-between h-10 mb-4 w-full rounded">
            <div class="w-full bg-primary p-2 rounded">
              <span class="text-xl ">Neuer Werbemitteltyp</span>
            </div>
          </div>
          <div class="flex flex-col sm:flex-row w-full">
            <div class="w-full">
              <div class="flex mt-2 text-center w-full">
                <span class="bg-primary w-1/4 p-2 rounded">Title</span>
                <input class="border p-2 rounded w-3/4" v-model="titleName" data-ui="titleName" :class="{'border p-2 rounded w-3/4 border-red-500': showError && !titleName}">
              </div>
              <div class="flex mt-2 text-center w-full">
                <span class="bg-primary w-1/4 p-2 rounded">Typ</span>
                <input class="border p-2 rounded w-3/4" v-model="type" data-ui="type" :class="{'border p-2 rounded w-3/4 border-red-500': showError && !type}">
              </div>
              <div class="flex mt-2 text-center w-full">
                <span class="bg-primary w-1/4 p-2 rounded">Supportet andere Märkte</span>
                <select class="border p-2 rounded w-3/4" v-model="supportMarkets" data-ui="supportMarkets" :class="{'border p-2 rounded w-3/4 border-red-500': showError && !supportMarkets}">
                  <option :value="true">Aktive </option>
                  <option :value="false">Nicht Aktiv</option>
                </select>
              </div>
              <button @click="createMagazineType" data-ui="create-magazine-type"  class=" mr-1 w-full rounded mt-2 p-3 bg-trader-green hover:bg-trader-blue hover:text-white transition duration-200 ease-in-out" >
                Erstellen
              </button>

            </div>
          </div>

        </div>
      </div>
    </div>

    <Sidebar />
  </div>
</template>


<script >

import Sidebar from "@/components/Administration/Sidebar.vue";
import {gql} from "@apollo/client/core";
import apolloClient from "@/apolloClient";
import router from "@/router";
import {eventBus} from "@/application/EventBus";
import SuccessConfirmation from "@/components/Dialogs/SuccessConfirmation.vue";
import SignalBus from "@/application/SignalBus";
import CGoBack from "@/components/Administration/CGoBack.vue";

export default {
  components: {CGoBack, Sidebar},
  data(){
    return{
      titleName: '',
      type: '',
      supportMarkets: '',
      showError: false,
      accordionIndex: 0,
    }
  },
  methods:{

    goBack(){
      router.push(`/administration`);
    },
    async createMagazineType(){

      if (!this.titleName || !this.type ) {
        this.showError = true;
        return;
      }
      this.showError = false;


      const magazineTypeData = {
        magazineType: this.type,
        magazineTypeTitle: this.titleName,
        supportsMarkets: this.supportMarkets,

      };

      const mutation = gql`
        mutation createMagazineType($magazineType: MarketTypeInput!) {
          createMagazineType(magazineType: $magazineType) {
            success
          }
        }
      `;

      try {
        const variables = {
          magazineType: magazineTypeData
        };
        const {data} = await apolloClient.mutate({mutation, variables});
        if (data.createMagazineType.success){
          eventBus.openModal(SuccessConfirmation);
          eventBus.setData({
            title: "WerbemittelTyp erstellt",
            message: "Der WerbemittelTyp wurde erstellt",
          });
          router.push(`/administration/${this.accordionIndex}`);
        }
      } catch (error) {
        console.error(error);
      }
    }
  },
  watch:{

  },
  created(){
    this.accordionIndex = this.$route.params.accordionIndex;
  }
}
</script>
